import {
  createSDMusicGroup, createSDMusicAlbum, createSDMusicRecording
} from './common';
import { truthyOrZero } from '@/helpers/math';
import pageKeys from '@/helpers/routing/constants';
import { extractSpecificImageFromAssetObj } from '@/helpers/assets';
import { SMALL_SQUARE_LABEL } from '@/config/assets';
import { generateSeasonEpisodeString } from '@/helpers/pages/channel';
import CONFIG from '@/config/global';

const { appName } = CONFIG;

export const createSDMusicGroupForShowHost = ({
  host, show, excludeContext = false
} = {}) => {
  const hostFormatted = (host || '').trim();
  const { slug } = show || {};

  if (!hostFormatted) {
    return null;
  }

  return createSDMusicGroup({
    id: hostFormatted,
    keakieUrlPath: pageKeys.shows(slug),
    name: hostFormatted,
    excludeContext
  });
};

export const createSDMusicAlbumForShow = ({ show, excludeContext = false } = {}) => {
  const {
    slug, title, release_date, assets, hosts
  } = show || {};

  if (!slug) {
    return null;
  }

  return createSDMusicAlbum({
    keakieUrlPath: pageKeys.shows(slug),
    name: title,
    datePublished: release_date ? new Date(release_date).toISOString().substring(0, 10) : undefined,
    imageUrl: extractSpecificImageFromAssetObj({
      assets,
      size: SMALL_SQUARE_LABEL
    }),
    byArtist: (hosts || [])
      .map((host) => createSDMusicGroupForShowHost({
        host,
        show,
        excludeContext: true
      }))
      .filter((h) => !!h),
    excludeContext
  });
};

export const createSDMusicRecordingForShowEpisode = ({ episode } = {}) => {
  const {
    show,
    release_date,
    description,
    season,
    episode_number
  } = episode || {};
  const {
    slug,
    assets,
    title: showTitle,
    hosts
  } = show || {};

  if (!truthyOrZero(season) || !truthyOrZero(episode_number)) {
    return null;
  }

  const seasonEpisodeText = generateSeasonEpisodeString({ episode });

  return createSDMusicRecording({
    keakieUrlPath: pageKeys.episode(slug, season, episode_number),
    name: seasonEpisodeText,
    datePublished: release_date ? new Date(release_date).toISOString().substring(0, 10) : undefined,
    imageUrl: extractSpecificImageFromAssetObj({
      assets,
      size: SMALL_SQUARE_LABEL
    }),
    description: `${ seasonEpisodeText } from ${ showTitle } on ${ appName }. ${ description }`,
    inAlbum: createSDMusicAlbumForShow({
      show,
      excludeContext: true
    }),
    byArtist: (hosts || [])
      .map((host) => createSDMusicGroupForShowHost({
        host,
        show,
        excludeContext: true
      }))
      .filter((h) => !!h)
  });
};